import { isEmpty } from 'lodash'
import { createSelectionListViewComponent } from 'factories/SelectionListView'
import { getStorageItem, updateStorageItem } from 'helpers/localStorage'

const getStorageKey = () => 'customer.offlineData.inventory'

export default createSelectionListViewComponent({
  pageTitleLanguageKey: 'locationGroup',
  allowInfiniteLoader: () => false,
  allowSearch: () => false,
  getValue: () => getStorageItem(getStorageKey())?.locationGroupIds ?? [],
  getOnChange: (self) => (each) => {
    updateStorageItem(getStorageKey(), {}, (draft) => {
      if (each.id === 0) {
        draft.locationGroupIds = []
      } else if (isEmpty(draft.locationGroupIds)) {
        draft.locationGroupIds = [each.id]
      } else {
        const index = draft.locationGroupIds.findIndex((one) => one === each.id)

        if (index > -1) {
          draft.locationGroupIds.splice(index, 1)
        } else {
          draft.locationGroupIds.push(each.id)
        }
      }
      draft.locationGroupNames = self.state.items
        .filter((item) => draft.locationGroupIds.includes(item.id))
        .map((item) => item.displayName)
        .join(', ')

      draft.locationIds = []
      draft.locationNames = ''
    })
  },
  allowMultiple: true,
})()
